import React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';
import Chart from 'react-apexcharts';
import totalDeviceAndScoreData from './fakedata/total_device_and_score.json';

const TotalDeviceAndScoreTable = () => {
    const currentMonthData = totalDeviceAndScoreData.months.February;
    const totalData = [currentMonthData.android, currentMonthData.ios];
    const iosCalculated = currentMonthData.iosScoreCount;
    const iosUncalculated = currentMonthData.ios - iosCalculated;
    const iosData = [iosCalculated, iosUncalculated];
    const androidCalculated = currentMonthData.androidScoreCount;
    const androidUncalculated = currentMonthData.android - androidCalculated;
    const androidData = [androidCalculated, androidUncalculated];

    const commonOptions = {
        chart: {
            type: 'donut',
            height: 250
        },
        legend: {
            position: 'bottom'
        },
        dataLabels: {
            offset: -10
        }
    };

    const totalOptions = {
        ...commonOptions,
        labels: ['Android Devices', 'iOS Devices']
    };

    const iosOptions = {
        ...commonOptions,
        labels: ['Calculated iOS Devices', 'Uncalculated iOS Devices']
    };

    const androidOptions = {
        ...commonOptions,
        labels: ['Calculated Android Devices', 'Uncalculated Android Devices']
    };

    return (
        <Card className="total-device-and-score-table">
            <CardHeader className="d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0 flex-grow-1">
                    <b>Total Device and Score</b>
                </h4>
            </CardHeader>
            <CardBody>
                <div className="d-flex justify-content-around">
                    <div id="totalDeviceChart" className="total-device-chart-container" style={{ width: '30%' }}>
                        <Chart
                            options={totalOptions}
                            series={totalData}
                            type="donut"
                            height={250}
                        />
                    </div>
                    <div id="iosDeviceChart" className="ios-device-chart-container" style={{ width: '30%' }}>
                        <Chart
                            options={iosOptions}
                            series={iosData}
                            type="donut"
                            height={250}
                        />
                    </div>
                    <div id="androidDeviceChart" className="android-device-chart-container" style={{ width: '30%' }}>
                        <Chart
                            options={androidOptions}
                            series={androidData}
                            type="donut"
                            height={250}
                        />
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default TotalDeviceAndScoreTable;
